/* ASC-CUSTOM (2026-09-17): welcome-gift popup behaviour (snippets/asc-invite-popup.liquid).
   Opens after a delay or at 40% scroll (homepage: after scrolling past the hero or 35 s, never during a hero intro;
   2026-11-01), then stays away for 30 days whether or not the visitor closed it
   (Murat 2026-09-18: one chance per visitor, no repeat on the next page view); a signup silences it for 365 days;
   ?asc_invite=1 forces it open (preview), ?asc_invite=posted shows the success state after the form POST.
   The two choices become customer tags through the hidden contact[tags] field (kit, business). */
(function () {
  var root = document.getElementById('asc-invite');
  if (!root) return;
  var KEY = 'asc_invite', DAY = 86400000, now = Date.now(), QUIET_DAYS = 30;
  var q = new URLSearchParams(location.search);
  var mode = root.getAttribute('data-mode') || 'off';
  var delay = Math.max(2, parseInt(root.getAttribute('data-delay'), 10) || 8) * 1000;
  var box = root.querySelector('.asc-invite__box');
  var opened = false, timer = null, fontsLoaded = false, shown = false, past = null, waitIntro = 0;
  /* 2026-09-27 (Murat): Christmas order-by reminder on gift pages (data-xmas="gift") inside the from/until window,
     or forced with ?asc_xmas=1. Signups get the tag xmas-reminder instead of welcome-gift (no W-N welcome email). */
  var xmas = false;
  function useXmas() {
    xmas = true;
    root.classList.add('is-xmas');
    root.querySelectorAll('[data-asc-v]').forEach(function (el) { el.hidden = el.getAttribute('data-asc-v') !== 'xmas'; });
    var img = root.querySelector('img[data-src-xmas]');
    if (img) {
      /* 2026-11-01: the phone banner (up to 600 px) takes the whole 16:9 poster, the tall desktop panel its 3:4 centre crop */
      var narrow = false;
      try { narrow = window.matchMedia('(max-width: 600px)').matches; } catch (e) {}
      img.setAttribute('data-src', (narrow && img.getAttribute('data-src-xmas-m')) || img.getAttribute('data-src-xmas'));
      img.alt = img.getAttribute('data-alt-xmas') || img.alt;
    }
    if (box) box.setAttribute('aria-labelledby', 'asc-invite-h-x');
  }

  function track(n, p) { try { if (window.asc && window.asc.track) window.asc.track(n, p); } catch (e) {} }
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function save(patch) { var s = load(); for (var k in patch) s[k] = patch[k]; try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
  function fonts() {
    if (fontsLoaded) return; fontsLoaded = true;
    var l = document.createElement('link'); l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&family=Playfair+Display:ital,wght@0,400;1,400&display=swap';
    document.head.appendChild(l);
  }
  function open(reason) {
    if (opened) return; opened = true;
    // 2026-10-08: the first opening disarms the other trigger, so closing the popup and then scrolling past 40% no longer
    // opens it a second time on the same page view (onScroll is hoisted; on the posted/forced paths it was never added).
    clearTimeout(timer); window.removeEventListener('scroll', onScroll);
    shown = true; if (past) past.disconnect(); clearInterval(waitIntro);
    fonts();
    var img = root.querySelector('img[data-src]');
    if (img) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); }
    root.hidden = false;
    document.documentElement.classList.add('asc-invite-open');
    var first = root.classList.contains('is-posted') ? root.querySelector('.asc-invite__success .asc-invite__claim') : root.querySelector('#asc-invite-email');
    try { (first || box).focus({ preventScroll: true }); } catch (e) {}
    // Seen once is enough: an ignored popup counts the same as a closed one, so it stays away for QUIET_DAYS.
    if (reason === 'delay' || reason === 'scroll') save({ shownAt: now });
    track('invite_shown', { reason: reason, variant: xmas ? 'xmas' : 'welcome' });
  }
  function close(reason) {
    if (!opened) return; opened = false;
    root.hidden = true;
    document.documentElement.classList.remove('asc-invite-open');
    if (reason !== 'after_signup') save({ dismissedAt: now });
    track('invite_dismiss', { reason: reason });
  }

  root.querySelectorAll('[data-asc-invite-close]').forEach(function (el) {
    el.addEventListener('click', function () { close(root.classList.contains('is-posted') ? 'after_signup' : 'dismiss'); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && opened) close('escape'); });

  var form = document.getElementById('asc-invite-form');
  if (form) {
    form.addEventListener('submit', function () {
      var tags = form.querySelector('[data-asc-invite-tags]');
      var kit = form.querySelector('[data-asc-invite-choice="kit"]');
      var biz = form.querySelector('[data-asc-invite-choice="business"]');
      if (xmas) {
        if (tags) tags.value = 'xmas-reminder,newsletter';
        save({ variant: 'xmas', submittedAt: now });
        track('invite_submit', { variant: 'xmas' });
        return;
      }
      var list = ['welcome-gift', 'newsletter'];
      if (kit && kit.checked) list.push('kit');
      if (biz && biz.checked) list.push('business');
      if (tags) tags.value = list.join(',');
      save({ variant: 'welcome', choice: { kit: !!(kit && kit.checked), business: !!(biz && biz.checked) }, submittedAt: now });
      track('invite_submit', { kit: !!(kit && kit.checked), business: !!(biz && biz.checked) });
    });
  }

  var success = root.querySelector('[data-asc-invite-success]');
  var errors = root.querySelector('.errors');
  var state = load();
  var posted = q.get('asc_invite') === 'posted' || (success && success.hasAttribute('data-posted'));

  if (root.getAttribute('data-xmas') === 'gift') {
    var xFrom = parseInt(root.getAttribute('data-xmas-from'), 10) * 1000, xUntil = parseInt(root.getAttribute('data-xmas-until'), 10) * 1000;
    var inWindow = now >= xFrom && now < xUntil;
    if (q.get('asc_xmas') === '1' || (posted ? state.variant === 'xmas' : inWindow)) useXmas();
  }

  if (posted) {
    var c = state.choice || {};
    var p = root.querySelector('[data-asc-invite-copy="personal"]'), b = root.querySelector('[data-asc-invite-copy="business"]'), k = root.querySelector('[data-asc-invite-copy="kit"]');
    if (p) p.hidden = !!c.business;
    if (b) b.hidden = !c.business;
    if (k) k.hidden = !c.kit;
    root.classList.add('is-posted');
    save({ subscribedAt: now, dismissedAt: 0 });
    open('posted');
    try { history.replaceState(null, '', location.pathname); } catch (e) {}
    return;
  }
  if (errors) { open('errors'); return; }
  if (q.get('asc_invite') === '1') { open('forced'); return; }
  if (mode !== 'on') return;
  if (state.subscribedAt && now - state.subscribedAt < 365 * DAY) return;
  if (state.dismissedAt && now - state.dismissedAt < QUIET_DAYS * DAY) return;
  if (state.shownAt && now - state.shownAt < QUIET_DAYS * DAY) return;
  // 2026-10-08 (Murat, ads diagnosis fix 1): on gift pages only the Christmas reminder fits. Outside its window the
  // wedding marker offer would open on a family sign, so nothing opens there.
  if (root.getAttribute('data-xmas') === 'gift' && !xmas) { track('invite_skip', { reason: 'offer' }); return; }
  // Murat 2026-09-26: a visitor who lands from an ad (Google click id or a paid utm_medium) sees the page first; the popup
  // waits for their second page view. The landing is remembered for the session only.
  var AD_KEY = 'asc_invite_ad';
  var fromAd = q.has('gclid') || q.has('gbraid') || q.has('wbraid') || /^(cpc|ppc|paid)/i.test(q.get('utm_medium') || '');
  if (fromAd) {
    try { sessionStorage.setItem(AD_KEY, location.pathname); } catch (e) {}
    track('invite_skip', { reason: 'ad_landing' });
    return;
  }
  // 2026-10-05 (Murat): never in the middle of a purchase. Not on the crossword designer, not while the cart has
  // something in it (checked again right before opening, the visitor may have added in the meantime).
  if (/crossword-generator/.test(location.pathname)) { track('invite_skip', { reason: 'designer' }); return; }
  if ((parseInt(root.getAttribute('data-cart'), 10) || 0) > 0) { track('invite_skip', { reason: 'cart' }); return; }
  // 2026-10-08 (Murat, ads diagnosis fix 1): never while the visitor is personalizing. A tap, key or change inside the
  // product form (Live Product Options builder, quantity, add to cart) holds the popup for the rest of this page view.
  // Nothing is saved, so it can still open on a later page.
  var busy = false, busyLogged = false;
  function onBuilder(e) { var t = e.target; if (!busy && t && t.closest && t.closest('product-form, .cl-po--wrapper')) busy = true; }
  ['pointerdown', 'keydown', 'input', 'change', 'focusin'].forEach(function (n) { document.addEventListener(n, onBuilder, true); });
  function held() { if (!busy) return false; if (!busyLogged) { busyLogged = true; track('invite_skip', { reason: 'builder' }); } return true; }
  // 2026-11-01 (hero v2 review): on the homepage the popup never covers the hero. It opens once the visitor has scrolled
  // past the hero, or 35 s after the page started loading (counted from the first touch, scroll or key as below, so it
  // can still never become the largest paint), whichever comes first, and it waits while a hero intro is loading or
  // playing (data-hx-busy on the Christmas slider, assets/asc-hero-xmas.js). Other pages keep the delay / 40% scroll.
  var hero = root.getAttribute('data-home') === '1' ? document.querySelector('[data-asc-hx], .asc-hero9') : null;
  var HOME_MS = 35000;
  function introBusy() { var h = document.querySelector('[data-asc-hx]'); return !!(h && h.hasAttribute('data-hx-busy')); }
  var openNow = open;
  open = function (reason) {
    if (opened || shown || held()) return;
    if (hero && introBusy()) {
      if (!waitIntro) waitIntro = setInterval(function () {
        if (shown) { clearInterval(waitIntro); waitIntro = 0; return; }
        if (introBusy()) return;
        clearInterval(waitIntro); waitIntro = 0; open(reason);
      }, 400);
      return;
    }
    // the builder can be touched while cart.js is in flight, so the hold is checked again before opening
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && c.item_count > 0) track('invite_skip', { reason: 'cart' }); else if (!held()) openNow(reason); })
      .catch(function () { if (!held()) openNow(reason); });
  };

  // 2026-09-30 (speed plan P3, Murat): the count starts at the visitor's first touch, scroll or key, not at page load,
  // so the popup can never become the page's largest paint (collection LCP 21.5 s -> 6.0 s in Lighthouse).
  var started = false, FIRST = ['pointerdown', 'touchstart', 'keydown', 'scroll', 'wheel'];
  function start() {
    if (started) return;
    started = true;
    FIRST.forEach(function (e) { window.removeEventListener(e, start, true); });
    var wait = hero ? Math.max(HOME_MS - (window.performance && performance.now ? performance.now() : 0), delay) : delay;
    timer = setTimeout(function () { open('delay'); }, wait);
  }
  FIRST.forEach(function (e) { window.addEventListener(e, start, { passive: true, capture: true }); });
  function onScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0 && window.scrollY / h >= 0.4) { window.removeEventListener('scroll', onScroll); clearTimeout(timer); open('scroll'); }
  }
  if (hero && 'IntersectionObserver' in window) {
    // homepage: "scrolled past" = the hero's bottom edge has left the top of the window
    past = new IntersectionObserver(function (es) {
      var e = es[es.length - 1];
      if (shown || e.isIntersecting || e.boundingClientRect.bottom > 0) return;
      past.disconnect();
      clearTimeout(timer);
      open('scroll');
    });
    past.observe(hero);
  } else {
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
